// import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        padding: 0,
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    placeholder: {
        position: 'absolute',
        left: 10,
    },
    paper: {
        // position: 'fixed',
        // zIndex: '9999',
        // marginTop: theme.spacing.unit,
        // left: 0,
        // right: 0,
        // maxHeight: 130,
        // overflow: 'auto',
    },
    divider: {
        // height: theme.spacing.unit * 2,
    },
});

function NoOptionsMessage(props) {
    return (
        <Typography
            style={{ backgroundColor: '#fcc' }}
            color="secondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            fullWidth
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.textFieldProps}
        />
    );
}

function Option(props) {
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontWeight: props.isSelected ? 500 : 400,
                fontSize: 14,
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    return (
        <Typography
            variant="body1"
            color="textSecondary"
            className={props.selectProps.classes.placeholder}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function Menu(props) {
    return (
        <Paper
            square
            className={props.selectProps.classes.paper}
            {...props.innerProps}
            style={{ position: 'fixed', zIndex: '1400' }}
        >
            {props.children}
        </Paper>
    );
}

const components = {
    Control,
    Menu,
    NoOptionsMessage,
    Option,
    Placeholder,
};

class ReactSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            single: '',
            suggestions: props.options,
        };
    }

    handleChange = value => {
        this.setState({
            single: value,
        });

        this.props.onSelected(value);
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.options.length > prevState.suggestions.length) {
            return {
                suggestions: nextProps.options,
            };
        }
        return null;
    }

    render() {
        const { classes, theme, label } = this.props;

        const selectStyles = {
            input: base => ({
                ...base,
                color: theme.palette.text.primary,
            }),
        };

        return (
            <div className={classes.root}>
                <Select
                    classes={classes}
                    styles={selectStyles}
                    options={this.state.suggestions}
                    components={components}
                    value={this.state.single}
                    onChange={this.handleChange}
                    placeholder="Start typing..."
                    textFieldProps={{
                        label: label,
                        margin: 'dense',
                        InputLabelProps: { shrink: true },
                    }}
                />
                {/* <div className={classes.divider} /> */}
            </div>
        );
    }
}

ReactSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ReactSelect);
